package kz.dentalcrm.app.screens.service_categories.list

import kotlinx.collections.immutable.toPersistentList
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kz.dentalcrm.app.core.base.BaseStateViewModel
import kz.dentalcrm.app.core.utils.Result
import kz.dentalcrm.app.domain.ServicesRepository
import kz.dentalcrm.app.screens.service_categories.list.mvi.ServiceCategoriesViewEvent
import kz.dentalcrm.app.screens.service_categories.list.mvi.ServiceCategoriesViewSideEffect
import kz.dentalcrm.app.screens.service_categories.list.mvi.ServiceCategoriesViewState
import org.koin.core.component.inject

class ServiceCategoriesViewModel :
    BaseStateViewModel<ServiceCategoriesViewEvent, ServiceCategoriesViewState, ServiceCategoriesViewSideEffect>() {

    private val servicesRepository: ServicesRepository by inject()

    override fun setInitialState() = ServiceCategoriesViewState()

    override fun handleEvents(event: ServiceCategoriesViewEvent) {
        when (event) {
            is ServiceCategoriesViewEvent.Search -> {
                setState { copy(search = event.query) }
                loadCategories()
            }
            ServiceCategoriesViewEvent.Reload -> {
                loadCategories()
            }
            is ServiceCategoriesViewEvent.EditCategory -> {
                setEffect {
                    ServiceCategoriesViewSideEffect.ShowEditCategory(
                        category = event.category
                    )
                }
            }
            is ServiceCategoriesViewEvent.DeleteCategory -> {
                setState {
                    copy(categories = categories.filter { it.id != event.id }.toPersistentList())
                }
            }
        }
    }

    private fun loadCategories() {
        setState {
            copy(
                screenState = ServiceCategoriesViewState.ScreenState.Loading
            )
        }
        launch(Dispatchers.Default) {
            when (val result = servicesRepository.getServiceCategories()) {
                is Result.Success -> {
                    val data = result.value
                    val filtered = if (viewState.value.search.isNotEmpty()) {
                        data?.filter { it.name?.contains(viewState.value.search, ignoreCase = true) == true }
                    } else {
                        data
                    }
                    setState {
                        copy(
                            categories = (filtered ?: emptyList()).toPersistentList(),
                            screenState = ServiceCategoriesViewState.ScreenState.Idle
                        )
                    }
                }
                is Result.Error -> {
                    setState {
                        copy(
                            screenState = ServiceCategoriesViewState.ScreenState.Error(
                                text = result.message ?: "Error loading categories"
                            )
                        )
                    }
                }
                else -> {
                    setState {
                        copy(
                            screenState = ServiceCategoriesViewState.ScreenState.Error(
                                text = "Unknown error"
                            )
                        )
                    }
                }
            }
        }
    }

    init {
        loadCategories()
    }
}
